module.exports = __webpack_public_path__ + "8ac4df7d7dc36d0321980399db6f7978.svg";